const Footer = {
  handleSubmenu: function () {
    // toggle menu footer nivel 1
    const menus = document.querySelectorAll(
      '[data-action="toggle-menu-footer"]'
    );

    menus.forEach((menu) => {
      menu.addEventListener('click', () => {
        menu.classList.toggle('open');
      });
    });
  },
  init: function () {
    const _this = this;

    _this.handleSubmenu();
  },
};

export default Footer;

// botao voltar ao topo
$("body").append("<a href='#' style='display: none;' class='scrollToTopButton'><span data-position='left center'></span><div>Voltar</div></a>"), $(window).scroll(function() {
  $(this).scrollTop() > 100 ? $(".scrollToTopButton").fadeIn() : $(".scrollToTopButton").fadeOut()
}), $(".scrollToTopButton").click(function() {
  return $("html, body").animate({
    scrollTop: 0
  }, 800), !1
  });
